/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Cookies from 'js-cookie';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { lt } from 'semver';

import NotificationModal from '../components/modals/NotificationModal';
import { AppActions } from '../actions/app';
import { AuthActions } from '../actions/auth';
import CurrentUserContext from '../contexts/CurrentUser';
import '../styles/App.css';
import versionConfig from '../version';
import IEWarning from '../components/states/IEWarning';

//window.location.reload(true);
class VersionNotificationAlert extends React.Component {
  handleClick = e => {
    e.preventDefault();
    window.location.reload(true);
  };

  render() {
    return (
      <div
        style={{ position: 'fixed', top: 0, right: 0 }}
        className="alert alert-warning"
        role="alert"
      >
        A new version of Sight is available!{' '}
        <a href={null} className="alert-link" onClick={this.handleClick}>
          Refresh page
        </a>
      </div>
    );
  }
}
const VersionNotification = () => (
  <Query
    pollInterval={60000}
    query={gql`
      query version {
        version
      }
    `}
  >
    {({ loading, error, data }) => {
      // if (loading) return 'Loading...';
      // if (error) return `Error! ${error.message}`;
      if (!loading && data && lt(versionConfig.version, data.version))
        return <VersionNotificationAlert />;
      return null;
    }}
  </Query>
);

class App extends Component {
  static propTypes = {
    user: PropTypes.object,
    show: PropTypes.bool,
    logout: PropTypes.func,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentElementState: true,
    };
  }

  handleClick() {
    // console.log('this state: ', this.state);
    this.setState({
      currentElementState: !this.state.currentElementState,
    });
  }

  /*
  componentWillMount() {
    console.log('--- App will mount');
    const { router, store } = this.context;

    // console.log('ROUTER', router);
    // router.addTransitionHook(createTransitionHook(store));

    const store$ = observableFromStore(this.context.store);

    if (__CLIENT__) {
      observables.didSetAuthToken(store$).subscribe((authToken) => {
        wsConnect(store);
      });

      observables.didSetCurrentProjectId(store$).subscribe((id) => {
        const subscribeToProject = {
          type: 'PROJECT_SUBSCRIBE',
          projectId: id
        };
        // ws.queueSend(JSON.stringify(subscribeToProject));
      });

      // observables.didLogin(store$).subscribe(accessToken => {
      //   this.context.store.dispatch(AuthActions.getMe()).then((res) => {
      //     const user = res.result.entities.users[res.result.result];

      //     const organizations = user.roles.organization;
      //     const accounts = user.roles.account;
      //     const projects = user.roles.project;

      //     if (Object.keys(organizations).length > 0) {
      //       return this.context.store.dispatch(push('/organizations'));
      //     }

      //     if (Object.keys(accounts).length > 0) {
      //       return this.context.store
      //         .dispatch(push(`/organizations/${Object.keys(organizations)[0]}/accounts`));
      //     }

      //     // must be on some project (need a page for a user who is not on any org/account/project)
      //     return this.context.store.dispatch(push(`/project/${Object.keys(projects)[0]}`));

      //     // return this.context.store.dispatch(push(`/accounts/${Object.keys(accounts)[0]}/projects`));

      //     // const adminOrganizations = organizations.filter((org) => {
      //     //   return org.role_id == 1;
      //     // });
      //     //
      //     // const adminAccounts = organizations.filter((acct) => {
      //     //   return acct.role_id == 1;
      //     // });
      //     //
      //     // if (adminOrganizations.length > 1) {
      //     //     // send them to pick an organization
      //     //   return this.context.store.dispatch(push('/organizations'));
      //     // }
      //     //
      //     // if (adminAccounts.length > 1) {
      //     //     // send them to pick an account
      //     //   return this.context.store.dispatch(push('/accounts'));
      //     // }
      //     //
      //     // if (adminOrganizations.length === 1 && adminAccounts.length === 1) {
      //     //   return this.context.store.dispatch(push(`/accounts/${accounts[0].id}/projects`));
      //     // }
      //     //
      //     // return this.context.store.dispatch(push(`/organizations/${organizations[0].id}/accounts`));
      //     // return this.context.store.dispatch(push(`/accounts/${accounts[0].id}`));
      //     // this.context.store.dispatch(pushState(null, '/dashboard'));
      //   });
      // });

      // observables.didLogout(store$).subscribe(accessToken => {
      //   console.log('LOGOUT!');
      //     // FIXME: this is causing issues with reset password
      //     // this.context.store.dispatch(push('/login'));
      // });
    }

    observables.didChangeProjectRoute(store$).subscribe(({ type, id }) => {
      console.log('>>> PROJECT ROUTE CHANGED');
      console.log('>>>', type, id);
      this.context.store.dispatch(ProjectTabActions.createTab(type, id));
    });
  }
  */

  handleLogout(event) {
    event.preventDefault();
    this.props.logout();
  }

  dismissNotices(notificationType, notificationIndex) {
    this.context.store.dispatch(AppActions.dismissNotices(notificationType, notificationIndex));
  }

  render() {
    // debugger;
    // console.log("APP PROPS: ", this.props)
    const display = this.props.show ? 'hidden' : 'initial';
    let style = { overflow: display, display: 'flex', flex: 1 };
    return (
      <div style={style}>
        {this.props.children}
        <VersionNotification />
        <NotificationModal
          notifications={this.props.notifications}
          type={['error', 'success']}
          dismiss={::this.dismissNotices}
        />
      </div>
    );
  }
}

@connect(state => ({
  user: state.users.getIn(['users', state.auth.get('user')]),
  showModal: state.modal.showModal,
  notifications: state.app.get('notifications'),
  isIE: state.browser.get('isIE'),
}))
export default class AppContainer extends Component {
  static propTypes = {
    user: PropTypes.object,
    showModal: PropTypes.bool,
    dispatch: PropTypes.func,
    notifications: PropTypes.instanceOf(Map),
  };

  componentDidMount() {
    const accessToken = Cookies.get('accessToken');

    this.props.dispatch(AppActions.setIEBool(/*@cc_on!@*/false || !!document.documentMode))

    if (accessToken) this.props.dispatch(AuthActions.getMe());
  }

  render() {
    const { user, showModal, notifications, isIE } = this.props;

    if (isIE) return <IEWarning />;

    return (
      <CurrentUserContext.Provider value={{ currentUser: user }}>
        <App
          locales={['en-US']}
          show={showModal}
          user={user}
          notifications={notifications}
        >
          {this.props.children}
        </App>
      </CurrentUserContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/App.js